import mock from '@giro-pdv/mocks/state.mock.json';

const initialState = {
  loading: null,
  data: null,
  session: null,
  terminal: null,
  message: null,
  error: [null, null],
  tef: {},
  status: null,
  present: null,
  transaction_status: null,
};

// export default mock.pdv.pinpad;
export default initialState;
